import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import { elementMatchesAny } from "../Global/tools.js";
import Type from "../Global/Typography.js";
import NanoFlex from "../Global/NanoFlex.js";
import Input from "./Input.js";
import { Popper, Reference, Manager } from "react-popper";

import { ReactComponent as Delete } from "../Global/icons/trash.svg";
import { ReactComponent as SearchIcon } from "../Global/icons/search.svg";
import { ReactComponent as ArrowUpGrey } from "../Global/icons/arrowTop.svg";
import { ReactComponent as ArrowDownGrey } from "../Global/icons/arrowDown.svg";

const StyledBlockBox = styled.div`
  width: 100%;
  height: ${32 + "px"}; /* 32px */
  padding: ${8 + "px"}; /* 8px */
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  background-color: ${(props) => (props.selected ? props.theme.color.primaryColors.transparencyPurple : props.theme.color.primaryColors.white)};

  .dropDownLine {
    p {
      font-weight: ${(props) => (props.selected ? `500` : `normal`)};
      color: ${(props) => (props.selected ? props.theme.color.primaryColors.darkPurple : props.theme.color.primaryColors.secFontColor)};
      width: 100%;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .deleteIcon {
      width: 25px;
      padding: 16px 0px;
      svg {
        height: 12px;
      }
      &:hover {
        svg {
          path {
            fill: ${(props) => props.theme.color.primaryColors.yellow};
          }
        }
      }
    }
  }
  &:first-child {
    background-color: ${(props) => props.theme.color.primaryColors.lightGrey};
  }
`;

const BlockBox = (props) => (
  <StyledBlockBox
    onClick={(e) => {
      /*Prevent Click on Delete Icon*/
      if (elementMatchesAny(e.target, [".deleteIcon"])) return;
      return props.blockBoxAction(props.index);
    }}
    selected={props.selected}>
    {props.content && (
      <NanoFlex className="dropDownLine" justifyContent={"flex-start"}>
        {/* <Check /> */}
        {props.customContent && props.customContent()}
        {!props.customContent && <Type.p>{props.content}</Type.p>}
        {props.delete && (
          <NanoFlex className="deleteIcon" onClick={() => props.deleteAction()}>
            <Delete />
          </NanoFlex>
        )}
      </NanoFlex>
    )}
  </StyledBlockBox>
);

const StyledMultipleSelectionDropdown = styled.div`
  width: 100%;
  border: 1px solid ${(props) => (props.selected ? props.theme.color.primaryColors.transparencyPurple : props.theme.color.primaryColors.lightGrey)};
  color: ${(props) => props.theme.color.main.font};
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  padding: 12px 20px;
  border-radius: 30px;
  font-size: 18px;
  font-family: ${(props) => props.theme.font};
  height: 53px;
  position: relative;

  @media only screen and (max-width: 1450px) {
    padding: 8px 20px;
    font-size: 14px;
    height: 38px;
  }

  @media only screen and (max-width: 1024px) {
    padding: 6px 12px;
    font-size: 12px;
  }

  .dropDownWrapper {
    width: 100%;
    top: 0;
    left: 0;
    .inputDropDownWrapper {
      width: 100%;
      height: 35px;

      .infoDropDownWrapper {
        background-color: white;
        border-radius: 11px 0 0 11px;
        overflow: hidden;

        p {
          color: ${(props) => (props.displayString ? props.theme.color.primaryColors.fontColor : props.theme.color.primaryColors.secFontColor)};
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .iconDropDownWrapper {
        width: 18px;
        padding-right: 1.5px;
        padding-top: 1.5px;
        border-radius: 0 11px 11px 0;
        background-color: white;
        svg {
          height: 18px;
          width: 18px;
        }
      }
    }
  }

  .inputSearchWrapper {
    position: sticky;
    top: 0;
    min-height: -webkit-fit-content;

    div {
      margin: 0;
      width: 100%;
      input {
        border: 0;
        border-bottom: 1px solid ${(props) => props.theme.color.primaryColors.lightGrey};
        border-radius: 0;
      }
    }
    .searchIconWrapper {
      position: absolute;
      height: auto;
      right: ${8 + "px"};
      width: ${24 + "px"};
      svg {
        width: 14px;
        height: 14px;
        path {
          fill: ${(props) => props.theme.color.primaryColors.lightGrey};
        }
      }
    }
  }
  .noResults {
    padding: 12px 20px;

    p {
      color: ${(props) => props.theme.color.primaryColors.secFontColor};
      opacity: 0.8;
    }

    @media only screen and (max-width: 1450px) {
      padding: 8px 20px;
    }
  }

  .dropDownContentWrapper {
    margin: 0;
    width: calc(100% + 2px);
    height: auto;
    max-height: 350px;
    overflow: auto;
    background: ${(props) => props.theme.color.primaryColors.white};
    z-index: 1;
    border-radius: 15px;
    margin-top: 12px;
    border: 1px solid ${(props) => (props.selected ? props.theme.color.primaryColors.lightPurple : props.theme.color.primaryColors.lightGrey)};

    @media only screen and (max-width: 1450px) {
      margin-top: 2px;
    }

    @media only screen and (max-width: 815px) {
      max-height: 250px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0);
    }

    input {
      border: 1px solid ${(props) => props.theme.color.primaryColors.lightGrey};
      padding: 12px 20px;
      border-top: none;
      border-right: none;
      border-left: none;

      @media only screen and (max-width: 1450px) {
        padding: 8px 20px;
      }

      @media only screen and (max-width: 1024px) {
        padding: 6px 12px;
      }

      &:focus {
        border: 1px solid ${(props) => props.theme.color.primaryColors.lightPurple};
        border-top: none;
        border-right: none;
        border-left: none;
      }
    }
  }
`;

class MultipleSelectionDropdown extends BaseComponent {
  constructor(props) {
    super(props);
    let selectedIds = this.props.selected ? this.props.selected : [];
    let options = this.props.options ? this.props.options : [];
    this.state = {
      term: "",
      options: options,
      selectedIds: selectedIds,
      isOpenDropdown: false,
    };

    this.nodeRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    document.addEventListener("mousedown", this.handleOutsideClick);
    /*Prevent different IsAllSelected States from Props to State */
    this.validateIsAllSelectedProp();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.state.selectedIds.sort()) !== JSON.stringify(prevState.selectedIds.sort())) {
      this.triggerOnChangeSelection();
    }
    if (JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected) || this.props.forceSelection) {
      this.setState({ selectedIds: this.props.selected ? this.props.selected : [], term: this.state.isOpenDropdown ? this.state.term : "" });
      this.validateIsAllSelectedProp();
    }
    if (JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
      let selectedIds = this.props.options
        .filter((v) => {
          return this.state.selectedIds.includes(v.id);
        })
        .map((v) => {
          return v.id;
        });

      this.setState({ options: this.props.options, selectedIds: selectedIds });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (!this.nodeRef.current.contains(e.target)) this.setState({ isOpenDropdown: false });
  };

  validateIsAllSelectedProp = () => {
    if (this.props.isAllSelected === true) {
      this.setState({
        selectedIds: this.state.options.map((v) => {
          return v.id;
        }),
      });
    }
  };

  triggerOnChangeSelection = () => {
    if (this.props.onChangeSelection) {
      this.props.onChangeSelection({
        isAllSelected: this.isAllSelected(this.state.options),
        selected: this.state.options.filter((v) => {
          return this.state.selectedIds.includes(v.id);
        }),
      });
    }
  };

  onOptionClick = (v) => {
    if (this.state.selectedIds.includes(v)) {
      this.setState({
        selectedIds: this.state.selectedIds.filter((id) => {
          return id !== v;
        }),
      });
    } else {
      this.setState({ selectedIds: [...this.state.selectedIds, ...[v]] });
    }
  };

  onSelectAllClick = () => {
    /*Get Filtered Results and ids */
    let results = this.getFilteredResults();
    let resultsIds = results.map((v) => v.id);
    /*Validate if is All Selected */
    if (this.isAllSelected(results)) {
      /*Get Ids Excluding current filtered results ids */
      let excludedSelectedIds = this.state.selectedIds.filter((v) => {
        return resultsIds.includes(v) === false;
      });
      this.setState({ selectedIds: excludedSelectedIds });
    } else {
      /*Merge filtered results ids and state selected ids and Distinct */
      let selectedIds = [...new Set([...resultsIds, ...this.state.selectedIds])];
      this.setState({
        selectedIds: selectedIds,
      });
    }
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  getDisplayString = () => {
    /*Add Custom Display String*/
    if (this.props.customDisplayString) {
      var event = {
        handled: false,
        selectedIds: [...this.state.selectedIds],
        displayString: null,
      };
      this.props.customDisplayString(event);
      if (event.handled) return event.displayString;
    }
    if (this.state.selectedIds.length === 0) return "";
    if (this.state.selectedIds.length === this.props.options.length) return "Todas as opções selecionadas";
    let selectedJoin = this.state.options
      .filter((v) => {
        return this.state.selectedIds.includes(v.id);
      })
      .map((v) => {
        return v.name;
      })
      .join(", ");
    if (selectedJoin.length <= 30) return selectedJoin;
    return `${this.state.selectedIds.length} Selecionadas`;
  };

  getFilteredResults = () => {
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.state.options.filter((v) => {
        let upperName = v.name.trim().toUpperCase();
        return upperName.includes(upperTerm);
      });
    } else {
      return this.state.options;
    }
  };

  isAllSelected = (results) => {
    let resultsIds = results.map((v) => v.id);
    let filteredSelectedIds = this.state.selectedIds.filter((v) => {
      return resultsIds.includes(v);
    });
    return filteredSelectedIds.length === results.length;
  };

  render() {
    let displayString = this.getDisplayString();
    let filteredResults = this.getFilteredResults();
    return (
      <StyledMultipleSelectionDropdown ref={this.nodeRef} className="dropDownContainer" displayString={displayString} indicator={this.state.selectedIds.length > 0}>
        <NanoFlex className="dropDownWrapper">
          <Manager>
            <Reference>
              {(targetProps) => {
                return (
                  <NanoFlex
                    ref={targetProps.ref}
                    className="inputDropDownWrapper"
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    onClick={() => {
                      this.setState({ isOpenDropdown: !this.state.isOpenDropdown });
                    }}>
                    <NanoFlex className="infoDropDownWrapper" justifyContent={"flex-start"}>
                      <Type.p>{displayString ? displayString : this.translation.recruitment.selectOption}</Type.p>
                    </NanoFlex>
                    <NanoFlex className="iconDropDownWrapper">{this.state.isOpenDropdown ? <ArrowUpGrey /> : <ArrowDownGrey className="svgMargin" />}</NanoFlex>
                  </NanoFlex>
                );
              }}
            </Reference>
            {this.state.isOpenDropdown && (
              <Popper placement={"bottom"}>
                {({ ref, style, placement, arrowProps }) => (
                  <NanoFlex ref={ref} style={style} data-placement={placement} className="dropDownContentWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
                    <NanoFlex className="inputSearchWrapper">
                      <Input title={null} defaultValue={this.state.term} placeholder={"Pesquisar" + "..."} onChangeAction={this.onTermChange} />
                      <NanoFlex className="searchIconWrapper">
                        <SearchIcon />
                      </NanoFlex>
                    </NanoFlex>
                    {filteredResults.length === 0 && (
                      <NanoFlex className="noResults">
                        <Type.p>Sem Resultados</Type.p>
                      </NanoFlex>
                    )}
                    {(!this.props.hideSelectAll || this.props.hideSelectAll === false) && filteredResults.length > 0 && <BlockBox content={"Selecionar tudo"} selected={this.isAllSelected(filteredResults)} blockBoxAction={this.onSelectAllClick} />}
                    {filteredResults.map((v, i) => {
                      return (
                        <BlockBox
                          key={`${i}_${v.id}`}
                          content={v.name}
                          selected={this.state.selectedIds ? this.state.selectedIds.includes(v.id) : false}
                          blockBoxAction={() => {
                            this.onOptionClick(v.id);
                          }}
                          delete={this.props.onDeleteClick ? true : false}
                          deleteAction={() => {
                            this.props.onDeleteClick(v.id);
                          }}
                          customContent={
                            this.props.customContent
                              ? () => {
                                  return this.props.customContent(v);
                                }
                              : null
                          }
                        />
                      );
                    })}
                  </NanoFlex>
                )}
              </Popper>
            )}
          </Manager>
        </NanoFlex>
      </StyledMultipleSelectionDropdown>
    );
  }
}

export default MultipleSelectionDropdown;
// --- // Documentation // --- //
/*
import MultipleSelectionDropdown from './../Nano/MultipleSelectionDropdown.js';
<MultipleSelectionDropdown
    options={ [] }
    onChangeSelection={(id) => console.log(id)}
/>
*/
